import classes from "./Offcanvas.module.css";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";


/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

function Offcanvas({
  show = true,
  id,
  style = {},
  close,
  padding = 16,
  ...rest
}) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    if (document.getElementById("overlay")) {
      document.getElementById("overlay").style.visibility = "visible";
    }
    return () =>
      (document.getElementById("overlay").style.visibility = "hidden");
  }, []);

  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  });

  return mounted
    ? createPortal(
        <>
          {show && (
            <div
              className={`offcanvas-backdrop" ${classes.backdrop} ${classes.show}`}
              onClick={close}
            ></div>
          )}
          <div
            className={`${classes.offcanvas} 
              ${show ? classes.show : ""}
              ${classes.offcanvas_left}`}
            style={{
              ...style,
            }}
          >
            {rest.children}
          </div>
        </>,
        document.getElementById("overlay")
      )
    : null;
}
export default Offcanvas;
